module.exports = __webpack_public_path__ + "static/Maestro-White-c5c49387b2c8ddee1d15d236addc70b7.svg";